import I18n from 'I18n';
import { useTeamNamesByTeamsSelectValue } from 'routing-ui/team/hooks/useTeamNamesByTeamsSelectValue';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const TeamsSelectValue = ({
  value
}) => {
  const {
    teamNames
  } = useTeamNamesByTeamsSelectValue(value);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: I18n.formatList(teamNames, {
      exclusive: true
    })
  });
};